(function () {
  var lastPanelSeen = null;

  function setHidden(el, hidden) {
    if (!el) return;
    if (el.hidden !== hidden) el.hidden = hidden;
  }

  function setText(el, text) {
    if (!el) return;
    if (el.textContent !== text) el.textContent = text;
  }

  function formatMoney(cents, currencyCode) {
    try {
      var locale = document.documentElement.lang || 'en-AU';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function refresh() {
    // Re-find the panel fresh every time rather than caching a reference: this
    // theme teleports the cart drawer's markup out of a <template> into a live
    // slot, and can re-clone that markup (which resets any DOM changes we made)
    // when the drawer opens or the cart updates. Re-querying means we always
    // sync whatever panel instance is currently live, however it got there.
    var panel = document.querySelector('[data-free-sticker-offer]');
    if (!panel) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // The panel we started this fetch for may have been replaced while the
        // request was in flight — re-find it again before touching the DOM.
        panel = document.querySelector('[data-free-sticker-offer]');
        if (!panel) return;

        var thresholdCents = parseInt(panel.getAttribute('data-threshold-cents'), 10) || 0;
        var stickerIds = (panel.getAttribute('data-sticker-product-ids') || '')
          .split(',')
          .map(function (s) {
            return s.trim();
          })
          .filter(Boolean);

        var hasItems = cart.item_count > 0;
        setHidden(panel, !hasItems);
        if (!hasItems) return;

        var currentLine = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (stickerIds.indexOf(String(cart.items[i].product_id)) !== -1) {
            currentLine = cart.items[i];
            break;
          }
        }

        var subtotal = cart.total_price;
        var unlocked = subtotal >= thresholdCents;

        var lockedEl = panel.querySelector('[data-fso-locked]');
        var unlockedEl = panel.querySelector('[data-fso-unlocked]');
        setHidden(lockedEl, unlocked);
        setHidden(unlockedEl, !unlocked);

        if (!unlocked && lockedEl) {
          var remaining = Math.max(0, thresholdCents - subtotal);
          setText(
            lockedEl.querySelector('[data-fso-remaining-text]'),
            '🎁 Spend ' + formatMoney(remaining, cart.currency) + ' more and pick any sticker free!'
          );
          var bar = lockedEl.querySelector('[data-fso-progress-bar]');
          if (bar) {
            var pct = Math.min(100, (subtotal / thresholdCents) * 100) + '%';
            if (bar.style.width !== pct) bar.style.width = pct;
          }
        }

        if (unlocked && unlockedEl) {
          setText(
            unlockedEl.querySelector('[data-fso-header]'),
            currentLine
              ? "🎉 You've unlocked a free sticker — your pick!"
              : "🎉 You've unlocked a free sticker — pick one!"
          );

          var options = unlockedEl.querySelectorAll('[data-fso-option]');
          for (var j = 0; j < options.length; j++) {
            var opt = options[j];
            var pid = opt.getAttribute('data-product-id');
            var available = opt.getAttribute('data-available') === 'true';
            if (!available) continue; // sold-out options never change based on cart contents

            var isCurrent = !!currentLine && String(currentLine.product_id) === pid;
            var isBlocked = !!currentLine && !isCurrent;

            opt.classList.toggle('fso-option--current', isCurrent);
            opt.classList.toggle('fso-option--muted', isBlocked);

            setHidden(opt.querySelector('[data-fso-state="current"]'), !isCurrent);
            setHidden(opt.querySelector('[data-fso-state="blocked"]'), !isBlocked);
            setHidden(opt.querySelector('[data-fso-state="available"]'), isCurrent || isBlocked);
          }
        }
      })
      .catch(function () {
        /* Leave the panel as last rendered — a failed cart.js fetch shouldn't break the drawer. */
      });
  }

  function init() {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        refresh();
      }, 200);
    });
    // Observe the whole document rather than a specific cart container: this
    // theme's cart drawer lives inside a <template> until it's teleported into
    // a live slot on first open, so there's no stable container to attach to
    // ahead of time. This still fires only on real element add/remove/text
    // changes (not on attribute or style changes), and refresh() only writes
    // to the DOM when a value actually changed, so it settles instead of
    // looping once the panel is in sync.
    observer.observe(document.documentElement, { childList: true, subtree: true });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
